import { render } from "./ModalCaptcha.vue?vue&type=template&id=260aceda&scoped=true"
import script from "./ModalCaptcha.vue?vue&type=script&lang=js"
export * from "./ModalCaptcha.vue?vue&type=script&lang=js"

import "./ModalCaptcha.vue?vue&type=style&index=0&id=260aceda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260aceda"]])

export default __exports__